<div
    class="sb-step-indicator overflow-x-auto invisible-scroll"
    style="max-width: calc(100vw - 2rem)"
>
    <ol class="d-inline-flex align-items-center" *ngIf="steps | keyvalue as stepArray">
        <li
            *ngFor="let step of stepArray; trackBy: trackByMethod"
            [class.sb-step-active]="
                step.value.state == 'active' || step.value.state == 'error'
            "
            [class.sb-step-completed]="
                step.value.state == 'completed' || step.value.state == 'success'
            "
            [class.sb-step-pending]="step.value.state == 'pending'"
            [class.sb-step-locked]="
                step.value.state == 'inactive' ||
                step.value.state == 'locked' ||
                (stepArray.length == activeStep && steps[activeStep].state == 'completed')
            "
            [class.sb-step-error]="step.value.state == 'error'"
        >
            <div [@stepBarAnimation]="step.value.state" class="sb-step-bar"></div>
            <a
                [routerLink]="
                    stepArray.length == activeStep &&
                    steps[activeStep].state == 'completed'
                        ? null
                        : step.value.path
                "
                [class.active]="step.key === activeStep"
            >
                <div class="sb-step-icon">
                    <ng-container [ngSwitch]="step.value.state">
                        <tabler-icon *ngSwitchDefault name="circle-dashed"></tabler-icon>
                        <tabler-icon
                            *ngSwitchCase="'active'"
                            name="circle-dashed"
                        ></tabler-icon>
                        <tabler-icon
                            *ngSwitchCase="'completed'"
                            name="circle-check"
                        ></tabler-icon>
                        <sb-pending-button-indicator
                            *ngSwitchCase="'pending'"
                            resetState="false"
                            state="loading"
                        ></sb-pending-button-indicator>
                        <sb-pending-button-indicator
                            resetState="false"
                            *ngSwitchCase="'error'"
                            state="error"
                        ></sb-pending-button-indicator>
                        <sb-pending-button-indicator
                            resetState="false"
                            *ngSwitchCase="'success'"
                            state="success"
                        ></sb-pending-button-indicator>
                    </ng-container>
                </div>
                <span class="visually-hidden">
                    {{ step.value.state === 'active' ? 'current' : step.value.state }}:
                </span>
                {{ step.value.title }}
            </a>
        </li>
    </ol>
</div>
